import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { to: '/about',      label: 'About Us'  },
  { to: '/philosophy', label: 'Philosophy'  },
  { to: '/services',   label: 'Our Services'  },
  { to: '/team',       label: 'Team'        },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => { setMobileOpen(false); }, [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`nav-bar${scrolled ? ' nav-bar--scrolled' : ''}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo" aria-label="Morphis Home">
            <img
              src="/assets/img/logo.png"
              alt="Morphis"
              onError={e => { e.target.src = 'https://placehold.co/110x36?text=Morphis'; }}
            />
          </Link>

          <ul className="nav-links" role="list">
            {navLinks.map(l => (
              <li key={l.to}>
                <NavLink to={l.to} className={({ isActive }) => isActive ? 'active' : ''}>
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="nav-cta">
            <Link to="/contact">Let's Connect</Link>
          </div>

          <button
            className={`nav-toggle${mobileOpen ? ' open' : ''}`}
            onClick={() => setMobileOpen(o => !o)}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile full-screen drawer */}
      <div
        className={`mobile-drawer${mobileOpen ? ' drawer-open' : ''}`}
        aria-hidden={!mobileOpen}
      >
        <ul className="mobile-nav-list" role="list">
          {navLinks.map(l => (
            <li key={l.to}>
              <NavLink to={l.to} className={({ isActive }) => isActive ? 'active' : ''}>
                {l.label}
              </NavLink>
            </li>
          ))}
          <li className="mobile-cta-item">
            <Link to="/contact" className="mobile-cta-link">Let's Connect</Link>
          </li>
        </ul>
      </div>

      {mobileOpen && (
        <div
          className="drawer-backdrop"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Navbar;
